<script>
    // this is only a fallback route to make https://pilabor.com/dev/ work
    import { goto } from '@roxi/routify'
    $goto(`./index`)
</script>
